import Client from "../AxiosClient";
const resource = "/private/briefings";
const resourceReport = "/private/briefings/report";

export default {
  //#region Conclusion
  async searchConclusion(id, month, year) {
    try {
      const result = await Client.get(
        `${resource}/searchconclusion?id=${id}&briefings_month=${month}&briefings_year=${year}`
      );
      return result;
    } catch (error) {
      return { error: error };
    }
  },

  async insConclusion(data) {
    try {
      const result = await Client.post(`${resource}`, data);
      return result;
    } catch (error) {
      return { error: error };
    }
  },

  async updConclusion(data) {
    try {
      const result = await Client.put(`${resource}`, data);
      return result;
    } catch (error) {
      return { error: error };
    }
  },

  async delConclusion(id) {
    try {
      const result = await Client.delete(`${resource}/${id}`);
      return result;
    } catch (error) {
      return { error: error };
    }
  },

  async getfileConclusion(id) {
    try {
      const result = await Client.get(`${resource}/getfile?id=${id}`);
      return result.data;
    } catch (error) {
      return { error: error };
    }
  },
  //#endregion

  //#region Report
  async searchReport(id, month, year, departmentId) {
    try {
      if (departmentId === -1) departmentId = "";
      const result = await Client.get(
        `${resourceReport}/searchreport?id=${id}&briefings_month=${month}&briefings_year=${year}&department_id=${departmentId}`
      );
      return result;
    } catch (error) {
      return { error: error };
    }
  },
  async exportReport(month, year) {
    try {
      const response = await Client.get(
        `${resourceReport}/exportreport?briefings_month=${month}&briefings_year=${year}`,
        {
          headers: {
            "Access-Control-Expose-Headers": "Content-Disposition",
          },
          responseType: "blob",
        }
      );
      return response;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },
  async insReport(data) {
    try {
      const result = await Client.post(`${resourceReport}`, data);
      return result;
    } catch (error) {
      return { error: error };
    }
  },

  async updReport(data) {
    try {
      const result = await Client.put(`${resourceReport}`, data);
      return result;
    } catch (error) {
      return { error: error };
    }
  },

  async delReport(id) {
    try {
      const result = await Client.delete(`${resourceReport}/${id}`);
      return result;
    } catch (error) {
      return { error: error };
    }
  },

  async getfileReport(id) {
    try {
      const result = await Client.get(`${resourceReport}/getfile?id=${id}`);
      return result.data;
    } catch (error) {
      return { error: error };
    }
  },
  //#endregion
};
